/* CruiseClip: the light/dark button, and the product picture tinted to the chosen colour.
   Progressive enhancement: without this file the site stays dark and the picture stays gold. */
(function () {
  'use strict';

  var root = document.documentElement;

  /* ---------- Light / dark ----------
     Dark is the default. The choice is kept in localStorage; theme-styles.liquid applies it before
     the page paints, so there's no flash of the wrong mode. */
  function setTheme(mode) {
    if (mode === 'light') root.setAttribute('data-theme', 'light'); else root.removeAttribute('data-theme');
    try { localStorage.setItem('cc-theme', mode); } catch (e) { /* private mode: the choice lasts this page only */ }
    syncToggles();
  }
  function syncToggles() {
    var light = root.getAttribute('data-theme') === 'light';
    Array.prototype.forEach.call(document.querySelectorAll('[data-theme-toggle]'), function (btn) {
      btn.setAttribute('aria-pressed', light ? 'true' : 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-theme-toggle]');
    if (btn) setTheme(root.getAttribute('data-theme') === 'light' ? 'dark' : 'light');
  });

  /* ---------- Picture tinted to the chosen colour ----------
     There are no product photos yet, so the gold CAD render is tinted with a CSS filter
     (see cruiseclip.css). The caption says the colour is illustrative. */
  var TINTS = ['black', 'white', 'grey', 'gray', 'brown'];
  function tintFor(name) {
    var n = String(name || '').trim().toLowerCase();
    return TINTS.indexOf(n) > -1 ? (n === 'gray' ? 'grey' : n) : '';
  }

  function tintGallery(section, value) {
    var slide = section.querySelector('.gallery__slide--render');
    if (!slide) return;
    var tint = tintFor(value);
    var cap = slide.querySelector('.gallery__caption');
    if (cap && !cap.hasAttribute('data-plain')) cap.setAttribute('data-plain', cap.textContent);
    if (tint) {
      slide.setAttribute('data-tint', tint);
      if (cap) cap.textContent = 'Shown in ' + String(value).trim() + '. Colour is illustrative, CAD render not a photo';
    } else {
      slide.removeAttribute('data-tint');
      if (cap) cap.textContent = cap.getAttribute('data-plain');
    }
  }

  function initProduct(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('[data-product-section]'), function (section) {
      var checked = section.querySelector('[data-option-group] input:checked');
      if (checked) tintGallery(section, checked.value);
      if (section.hasAttribute('data-tint-ready')) return;
      section.setAttribute('data-tint-ready', '');
      section.addEventListener('change', function (e) {
        var input = e.target;
        if (input && input.closest && input.closest('[data-option-group]')) tintGallery(section, input.value);
      });
    });
  }

  /* Bag: tint each item's picture to its colour (the colour is in the line's variant title). */
  function tintBag(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('.bag-item'), function (item) {
      var meta = item.querySelector('.bag-item__meta');
      var img = item.querySelector('.bag-item__img');
      var tint = meta && tintFor(meta.textContent.split('/')[0]);
      if (img && tint) img.setAttribute('data-tint', tint);
    });
    var drawerMeta = scope.querySelector('[data-drawer-meta]');
    var drawerImg = scope.querySelector('[data-drawer-img]');
    if (drawerMeta && drawerImg && 'MutationObserver' in window) {
      new MutationObserver(function () {
        var tint = tintFor(drawerMeta.textContent.split(/[\/·]/)[0]);
        if (tint) drawerImg.setAttribute('data-tint', tint); else drawerImg.removeAttribute('data-tint');
      }).observe(drawerMeta, { childList: true, characterData: true, subtree: true });
    }
  }

  function init() {
    syncToggles();
    initProduct(document);
    tintBag(document);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function (e) { initProduct(e.target); tintBag(e.target); syncToggles(); });
})();
